"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createElementPropsSDKFactory = exports.elementPropsSDKFactory = exports.toJSONBase = void 0;
const corvidEvents_1 = require("../corvidEvents");
const composeSDKFactories_1 = require("../composeSDKFactories");
const messages_1 = require("../messages");
const reporters_1 = require("../reporters");
const basePropsSDKFactory_1 = require("./basePropsSDKFactory");
const viewportPropsSDKFactory_1 = require("./viewportPropsSDKFactory");
const visibilityPropsSDKFactory_1 = require("./visibilityPropsSDKFactory");
const effectsTriggersSDKFactory_1 = require("./effectsTriggersSDKFactory");
const toJSONBase = ({ role, compType, isGlobal, isRendered, }) => ({
    id: role,
    type: `$w.${compType}`,
    global: isGlobal(),
    rendered: isRendered(),
});
exports.toJSONBase = toJSONBase;
const _elementPropsSDKFactory = api => ({
    onMouseIn: handler => (0, corvidEvents_1.registerCorvidMouseEvent)('onMouseEnter', api, handler),
    onMouseOut: handler => (0, corvidEvents_1.registerCorvidMouseEvent)('onMouseLeave', api, handler),
    removeEventHandler: (type, handler) => {
        const { getSdkInstance } = api;
        if (typeof type !== 'string') {
            (0, reporters_1.reportError)(messages_1.messageTemplates.error_type({
                propertyName: 'type',
                functionName: 'removeEventHandler',
                value: type,
                expectedType: 'string',
            }));
            return getSdkInstance();
        }
        if (typeof handler !== 'function') {
            (0, reporters_1.reportError)(messages_1.messageTemplates.error_type({
                propertyName: 'handler',
                functionName: 'removeEventHandler',
                value: handler,
                expectedType: 'function',
            }));
            return getSdkInstance();
        }
        return (0, corvidEvents_1.unregisterCorvidEvent)(type, api, handler);
    },
    get rendered() {
        return api.metaData.isRendered();
    },
    toJSON() {
        return (0, exports.toJSONBase)(api.metaData);
    },
});
const viewportPropsSDKFactory = (0, viewportPropsSDKFactory_1.createViewportPropsSDKFactory)();
exports.elementPropsSDKFactory = (0, composeSDKFactories_1.composeSDKFactories)(basePropsSDKFactory_1.basePropsSDKFactory, viewportPropsSDKFactory, _elementPropsSDKFactory, effectsTriggersSDKFactory_1.effectsTriggersSDKFactory);
const createElementPropsSDKFactory = ({ useHiddenCollapsed = true, hasPortal = false, } = {}) => {
    return (0, composeSDKFactories_1.composeSDKFactories)(basePropsSDKFactory_1.basePropsSDKFactory, _elementPropsSDKFactory, effectsTriggersSDKFactory_1.effectsTriggersSDKFactory, useHiddenCollapsed
        ? (0, visibilityPropsSDKFactory_1.createVisibilityPropsSDKFactory)(hasPortal)
        : viewportPropsSDKFactory);
};
exports.createElementPropsSDKFactory = createElementPropsSDKFactory;
//# sourceMappingURL=elementPropsSDKFactory.js.map